import React, { createContext, useContext, useState, useEffect } from 'react';

const UIContext = createContext();

const styles = {
  small: {
    inputStyle: {
      padding: '2px 4px',
      fontSize: '0.8em'
      
    },
    textStyle: {
      fontSize: '0.85em',
      lineHeight: '1.4'
    }
  },
  medium: {
    inputStyle: {
      padding: '3px 6px',
      fontSize: '0.9em'
    },
    textStyle: {
      fontSize: '1em',
      lineHeight: '1.4'
    }
  },
  large: {
    inputStyle: {
  padding: '4px 8px',
  fontSize: '1.05em',            // ⬅️ reduced from 1.05em
  minWidth: '140px'
},
textStyle: {
  fontSize: '1.1em',          // ⬅️ reduced from 1.2em
  lineHeight: '1.4'           // ⬅️ slightly tighter
}

  }

};

export function UIProvider({ children, initialUiSize }) {
  const [uiSize, setUiSize] = useState(null);

  useEffect(() => {
    if (initialUiSize) {
      setUiSize(initialUiSize);
    }
  }, [initialUiSize]);

  useEffect(() => {
    if (!uiSize) return;
    document.body.setAttribute('data-ui-size', uiSize);
    localStorage.setItem('uiSize', uiSize);
  }, [uiSize]);




  useEffect(() => {
    const handler = () => {
      //if (window.innerWidth < 600) setUiSize('large');
      //else setUiSize('medium');
    };
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  useEffect(() => {
    document.body.setAttribute('data-ui-size', uiSize);
  }, [uiSize]);

useEffect(() => {
  const storedTheme = localStorage.getItem('theme');
  if (storedTheme) {
    const themes = ['theme-light', 'theme-dark', 'theme-sepia', 'theme-blueprint', 'theme-custom'];
    themes.forEach(t => document.body.classList.remove(t));
    document.body.classList.add(`theme-${storedTheme}`);

    if (storedTheme === 'custom') {
      const bg = localStorage.getItem('customBgColor') || '#ffffff';
      const yiq = (parseInt(bg.slice(1, 3), 16) * 299 +
                   parseInt(bg.slice(3, 5), 16) * 587 +
                   parseInt(bg.slice(5, 7), 16) * 114) / 1000;
      const textColor = yiq >= 128 ? '#000000' : '#ffffff';

      document.documentElement.style.setProperty('--custom-bg', bg);
      document.documentElement.style.setProperty('--custom-text', textColor);
      document.documentElement.style.setProperty('--custom-button-bg', bg);
      document.documentElement.style.setProperty('--custom-button-text', textColor);
    }
  }
}, []);


  return (
  <UIContext.Provider value={{ uiSize, setUiSize: (size) => {
    setUiSize(size);
    localStorage.setItem('uiSize', size);
  }}}>
      {children}
    </UIContext.Provider>
  );
}

export function useUI() {
  const context = useContext(UIContext);
  const size = styles[context.uiSize] || styles.medium;

  const cardStyle = {
    backgroundColor: 'var(--import-bg)',
    color: 'var(--text-primary)',
    border: '1px solid var(--card-border)',
    borderRadius: '10px',
    padding: '10px'
  };

  const abcEditorStyle = {
    backgroundColor: 'var(--input-bg)',
    color: 'var(--input-text, var(--text-primary))',
    padding: '8px',
    borderRadius: '6px',
    border: '1px solid var(--card-border)',
    fontFamily: 'monospace',
    lineHeight: '1.4',
    resize: 'none'
  };

  return {
    ...context,
    inputStyle: size.inputStyle,
    textStyle: size.textStyle,
    cardStyle,
    abcEditorStyle
  };
}
